<template>
  <qb-sidebar
    :name="name"
    :title="data.client_name | upperCase"
    :bgColor="data.status_color"
    textColor="#fff"
    size="sm"
    :loading="loading"
    @open="open"
  >
    <template v-slot:header>
      <vs-row vs-justify="center" class="px-4 mb-4 f-14">
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $t('date') | capitalize }} :
            {{ formatDate(data.date_expedition) }}
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $tc('type', 1) | capitalize }} :
            {{ data.type_name | capitalize }}
          </p>
        </vs-col>
        <vs-col vs-type="flex" vs-w="12">
          <p>
            {{ $tc('agency') | capitalize }} :
            {{ data.category_name | capitalize }}
          </p>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="p-4 mb-4">
        <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
          <qb-status-card
            :textColor="data.status_color"
            :text="data.status_name"
          />
        </vs-col>
      </vs-row>
    </template>
    <vs-row vs-justify="flex-center" class="px-4 mb-4">
      <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
        <dashboard-pdf-viewer
          class="w-full"
          :files="files"
          :title="data.client_name"
        />
      </vs-col>
    </vs-row>

    <vs-row vs-justify="flex-center" class="px-4 mb-4">
      <vs-col vs-w="12"  class="px-4">
          <p class="mb-4 f-bold f-18">{{ data.name | capitalize }}</p>
          <p class="mb-4">
            {{ data.third | capitalize }}
          </p>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="flex-center" class="px-4 mb-4">
      <vs-col vs-w="12">
        <vs-table noDataText="" :data="[]">
          <template slot="thead">
            <vs-th class="text-center f-12">
              {{ $t('expiration_date') | capitalize }}
            </vs-th>
            <vs-th class="text-center f-12">
              {{ $t('remaining_days') | capitalize }}
            </vs-th>
            <vs-th class="text-center f-12 text-danger">
              {{ $t('cost') | capitalize }}
            </vs-th>
            <vs-th class="text-center f-12 text-success">
              {{ $t('savings') | capitalize }}
            </vs-th>
          </template>
          <template>
            <vs-tr>
              <vs-td class="text-center">{{
                formatDate(data.date_expiration)
              }}</vs-td>
              <vs-td class="text-center">{{
                getRemainingDays(data.date_expiration)
              }}</vs-td>
              <vs-td>
                $ {{ formatNumber(data.cost) }}
                {{ data.currency | upperCase }}
              </vs-td>
              <vs-td>
                $ {{ formatNumber(data.savings) }}
                {{ data.currency | upperCase }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="flex-center" class="px-4 mb-4 f-14">
      <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-4 px-2">
        <p class="mb-2 f-bold f-14 text-center">
          {{ $t('tacna_responsibility') | capitalize }}
        </p>
        <p>
          {{ data.responsibility_tacna | capitalize }}
        </p>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-4 px-2">
        <p class="mb-2 f-bold f-14 text-center">
          {{ $t('client_responsibility') | capitalize }}
        </p>
        <p>
          {{ data.responsibility_customer | capitalize }}
        </p>
      </vs-col>
    </vs-row>
  </qb-sidebar>
</template>
<script>
import QbSidebar from '@/views/qb-components/QbSidebar'
import QbStatusCard from '@/views/qb-components/QbStatusCard'
import dashboard from '@/http/requests/dashboard'
import moment from 'moment'
import DashboardPdfViewer from '../components/pdf/DashboardPdfViewer.vue'
import { BASE_URL, URL_EXPORT_CSV, URL_CUSTOM_REPORT } from '@/urls.js'

export default {
  name: 'ehs-details',
  components: {
    QbSidebar,
    QbStatusCard,
    DashboardPdfViewer,
  },
  props: {
    ehsId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      name: 'sidebar-ehs-details',
      loading: false,
      data: {},
      files: [],
    }
  },
  methods: {
    open() {
      this.getData()
    },
    getRemainingDays(expirationDate) {
      let today = moment()
      let expiration = moment(expirationDate)
      let remainingDays = expiration.diff(today, 'days')

      if (remainingDays < 0) {
        return 0
      }
      return remainingDays
    },
    getData() {
      this.loading = true
      dashboard
        .ehsDetails(this.ehsId)
        .then((response) => {
          this.data = { ...response.data.result }
          this.loading = false
          this.files = []
          this.files.push({ pdf: BASE_URL + 'storage/' + this.data.file })
        })
        .catch((response) => {
          console.log(response)
          this.loading = false
        })
    },
  },
}
</script>

<style>
.vs-table-text {
}
</style>
